import { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography, Button } from "@material-ui/core";
import format from "date-fns/format";
import images from "src/assets/chat";
interface MessageProps {
  message: Message;
}

const Message: FC<MessageProps> = ({ message }: MessageProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div
        className={`${classes.message} ${
          message.senderType === "myself"
            ? classes.senderMyself
            : classes.senderBot
        }`}
      >
        {message.file && message.fileType === "image" && (
          <img
            className={classes.image}
            // @ts-ignore
            src={images.documents[message.file].default}
          ></img>
        )}
        <Typography className={classes.text}>
          {message.text}{" "}
          {message.file && message.fileType === "download" && (
            <a href={message.file} download>
              {message.downloadName}
            </a>
          )}
        </Typography>
        <Typography className={classes.date}>
          {format(message.timestamp, "hh:mm")}
        </Typography>
      </div>
      {message.senderType === "bot" && message.callbackButtons && (
        <div>
          {message.callbackButtons?.map(
            (callbackButton: ChatCallbackButton, index: number) => (
              <Button
                className={classes.callbackButton}
                key={index}
                onClick={() => callbackButton.callback(callbackButton.value)}
              >
                {callbackButton.title}
              </Button>
            )
          )}
        </div>
      )}
    </div>
  );
};

Message.defaultProps = {};

export default Message;

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  message: {
    display: "grid",
    gridTemplateColumns: "6fr 1fr",
    position: "relative",
    width: "60%",
    margin: "14px 0 0 0",
    padding: "18px 13px 19px 23px",
    borderRadius: "8px",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    rowGap: "14px",
  },
  callbackButton: {
    width: "70%",
    margin: "8px 0 0 0",
    padding: "10px 13px 10px 23px",
    float: "left",
    left: "5%",
    backgroundColor: "rgb(156,173,185, 20%)",
    fontWeight: 600,
    textTransform: "none",
  },
  senderMyself: {
    backgroundColor: "#dcf9c4",
    float: "right",
    right: "5%",
  },
  senderBot: {
    backgroundColor: "#fff",
    float: "left",
    left: "5%",
  },
  image: {
    gridColumn: "1 / span 2",
    width: "95%",
    borderRadius: "6%",
  },
  text: {
    margin: "0",
    fontSize: "13px",
    fontWeight: 500,
    color: "#1d262c",
    overflowWrap: "anywhere",
  },
  date: {
    opacity: "0.43",
    fontFamily: "Poppins",
    fontSize: "11px",
    fontWeight: 500,
    color: "#1d262c",
    textAlign: "right",
    alignSelf: "end",
  },
}));
